import useSWR from 'swr';
import axiosInstance from '@/lib/axiosInstance';

export function useConversations() {
  const { data, error, mutate } = useSWR(`/api/chat/conversations`, (url) => axiosInstance.get(url).then(r => r.data.data));
  return { conversations: data || [], loading: !data && !error, error, mutate };
}

export function useMessages(conversationId: string | null, params?: { before?: string }) {
  const key = conversationId ? `/api/chat/conversations/${conversationId}/messages${params?.before ? `?before=${params.before}` : ''}` : null;
  const { data, error, mutate } = useSWR(key, (url) => axiosInstance.get(url).then(r => r.data.data));
  return { messages: data || [], loading: !!conversationId && !data && !error, error, mutate };
}
